import React from "react";
import { C, font, badge } from "../../../../lib/styles.js";
import { SESSION_TYPE_LABELS, SESSION_TYPE_COLORS, STUDIO_ADDRESS_PARTS } from "../../../../lib/constants.js";
import { fmtTime, fmtDate, FMT_DATE_DOW, addressMapQuery, sessionHasCaptureData } from "../../../../lib/utils.js";

const STC = SESSION_TYPE_COLORS(C);

export default function SessionStrip({
  sortedSessions, selectedIndex, canEdit,
  onSelect, onRequestDelete, onImmediateDelete,
}) {
  const dateCounts = {};
  sortedSessions.forEach(s => { const d = s?.date || ""; if (d) dateCounts[d] = (dateCounts[d] || 0) + 1; });
  const maxCaptureDate = sortedSessions
    .filter(s => s?.sessionType === "capture" && s?.date)
    .reduce((a, s) => s.date > a ? s.date : a, "");
  const dateSeen = {};

  return (
    <div>
      {sortedSessions.map((s, si) => {
        const d = s?.date || "";
        if (d) dateSeen[d] = (dateSeen[d] || 0) + 1;
        const sharedCount = dateCounts[d] || 1;
        const sharedIdx = dateSeen[d] || 1;
        const isShared = sharedCount > 1 && !!d;
        const isSetupAfterCapture = s?.sessionType === "setup" && !!d && !!maxCaptureDate && d > maxCaptureDate;
        const dateDisplay = fmtDate(d, FMT_DATE_DOW) || "—";
        const venue = s?.isStudio ? STUDIO_ADDRESS_PARTS.venue : (s?.locationVenue || s?.location || "");
        const addrParts = [s?.locationAddress, s?.locationCity, s?.locationState].filter(Boolean).join(", ");
        const mapQuery = addressMapQuery(s);
        const isSelected = selectedIndex === si;
        const hasCaptureData = sessionHasCaptureData(s);
        return (
          <div key={s?.id || `sess-${si}`}>
            <div
              className="jd-session-row"
              onClick={() => onSelect(isSelected ? null : si)}
              style={{
                display: "grid",
                gridTemplateColumns: "28px 140px 80px 80px 1fr 28px 80px 20px",
                gap: 10, alignItems: "center", padding: "10px 2px",
                borderBottom: `1px solid ${C.border}`,
                cursor: "pointer",
                background: isSelected ? `${C.amber}12` : "transparent",
              }}
            >
              <div style={{ fontSize: 11, color: C.muted }}>{si + 1}</div>
              <div>
                <div style={{ fontSize: 13, color: C.text }}>{dateDisplay}</div>
                {isShared && <div style={{ fontSize: 10, color: C.amber, marginTop: 2 }}>Shared day · {sharedIdx} of {sharedCount}</div>}
              </div>
              <div style={{ fontSize: 12, color: s?.callTime ? C.text : C.muted, fontStyle: s?.callTime ? "normal" : "italic" }}>{s?.callTime ? fmtTime(s.callTime) : "TBD"}</div>
              <div style={{ fontSize: 12, color: s?.wrapTime ? C.text : C.muted, fontStyle: s?.wrapTime ? "normal" : "italic" }}>{s?.wrapTime ? fmtTime(s.wrapTime) : "TBD"}</div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 12, color: C.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{venue || "—"}</div>
                {addrParts && <div style={{ fontSize: 11, color: C.muted, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{addrParts}</div>}
              </div>
              <div style={{ textAlign: "center" }}>
                {!s?.isStudio && mapQuery ? (
                  <a
                    href={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(mapQuery)}
                    target="_blank" rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    title="Open in Google Maps"
                    style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 22, height: 22, borderRadius: 4, color: C.blue }}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={C.blue} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </a>
                ) : null}
              </div>
              <div style={{ textAlign: "right" }}>
                <span style={badge(STC[s?.sessionType] || C.muted)}>{SESSION_TYPE_LABELS[s?.sessionType] || s?.sessionType || "—"}</span>
              </div>
              <div style={{ textAlign: "center" }}>
                {canEdit && (
                  <button
                    onClick={e => {
                      e.stopPropagation();
                      if (hasCaptureData) onRequestDelete(s?.id || null);
                      else onImmediateDelete(s?.id || null);
                    }}
                    title="Remove session"
                    style={{ background: "transparent", border: "none", color: C.muted, cursor: "pointer", fontSize: 16, padding: 0, lineHeight: 1, fontFamily: font }}
                    onMouseEnter={e => e.currentTarget.style.color = C.danger}
                    onMouseLeave={e => e.currentTarget.style.color = C.muted}
                  >×</button>
                )}
              </div>
            </div>
            {isSetupAfterCapture && (
              <div style={{
                background: `${C.danger}10`, border: `1px solid ${C.danger}30`, borderRadius: 6,
                padding: "8px 12px", fontSize: 11, color: C.danger,
                margin: "6px 0", display: "flex", alignItems: "center", gap: 8,
              }}>
                <span>Setup typically comes before capture. This setup is after your capture sessions — did you mean Strike?</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

